import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Loader = ({ loading = false }) => {
  if (!loading) return null; // don't render anything if false

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.7)", // semi-transparent overlay
        zIndex: 9999,
      }}
    >
      <CircularProgress size={45} sx={{ color: "#0b006c" }} />
    </Box>
  );
};

export default Loader;
